import { queryDepExpendEconomicClassify } from '@/routes/Salary/services';
import {
  confirmImport,
  editBudgetAccountSubject,
  getBudgetAccountSubjectList,
  getLedgerTemplate,
  makeTagBudgetAccountSubject,
  queryLedgerImportResult,
  removeTagBudgetAccountSubject,
  submitLedgerTask,
  updateDepartmentEconomyClassify,
} from '../services';

export default {
  namespace: 'subjectConfig',
  state: {},
  effects: {
    *queryLedgerImportResult({ payload }, { call }) {
      const result = yield call(queryLedgerImportResult, payload);
      return result;
    },
    *confirmImport({ payload }, { call }) {
      const result = yield call(confirmImport, payload);
      return result;
    },
    *getLedgerTemplate({ payload }, { call }) {
      const result = yield call(getLedgerTemplate, payload);
      return result;
    },
    *submitLedgerTask({ payload }, { call }) {
      const result = yield call(submitLedgerTask, payload);
      return result;
    },
    *getBudgetAccountSubjectList({ payload }, { call }) {
      const result = yield call(getBudgetAccountSubjectList, payload);
      return result;
    },
    *editBudgetAccountSubject({ payload }, { call }) {
      const res = yield call(editBudgetAccountSubject, payload);
      return res;
    },
    *removeTagBudgetAccountSubject({ payload }, { call }) {
      const res = yield call(removeTagBudgetAccountSubject, payload);
      return res;
    },
    *makeTagBudgetAccountSubject({ payload }, { call }) {
      const res = yield call(makeTagBudgetAccountSubject, payload);
      return res;
    },
    *queryDepExpendEconomicClassify({ payload }, { call }) {
      const res = yield call(queryDepExpendEconomicClassify, payload);
      return res;
    },
    *updateDepartmentEconomyClassify({ payload }, { call }) {
      const res = yield call(updateDepartmentEconomyClassify, payload);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
